import React, { Component } from 'react'
import PropTypes from 'prop-types';
import likeIcon from './../../img/pros-cons-like.svg'
import dislikeIcon from './../../img/pros-cons-dislike.svg'
import { overlayStyle } from '../../styles/common-styles';
import './pros-cons.scss';

class ProsCons extends Component {
  render() {
    const {cons, pros} =  this.props;
    if (!cons && !pros) {
      return null
    }

    return (
      <div className="pros-cons">
        <div className="pros-cons__content">
          
          <div className="pros-cons__list pros-cons__list--green">
            <span className="pros-cons__icon" >
              <amp-img src={likeIcon} width="25" height="25" layout="flex-item" alt="like icon"></amp-img>
            </span>

            <div className="pros-cons__title">Pros</div>
            <ul>
              {pros.map((item, i) => (
                <li key={i}>
                  <span className="pros-cons__text pros-cons__text--pros">{item.replace(/;/g, ',')}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="pros-cons__list pros-cons__list--red">
            <span className="pros-cons__icon" style={overlayStyle}> 
              <amp-img src={dislikeIcon} width="25" height="25" layout="flex-item" alt="like icon"></amp-img>
            </span>
            <div className="pros-cons__title">Cons</div>
            <ul>
              {cons.map((item, i) => (<li key={i}>
                <span className="pros-cons__text pros-cons__text--cons">{item.replace(/;/g, ',')}</span>
              </li>))}
            </ul>
        </div>
      </div>
      </div>
    )
  }
}

ProsCons.propTypes = {
  cons: PropTypes.array,
  pros: PropTypes.array
};

export default ProsCons;


// WEBPACK FOOTER //
// ./src/components/pros-cons/pros-cons.js